module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0d34c80e3919306cb722380e920cffac.png";